
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#F1F4F9"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"40","height":"40"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#C4C4C4"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('ellipse',{attrs:{"cx":"20","cy":"35.2","rx":"15.2","ry":"8.8","fill":"#DAE2EC"}})]),_c('circle',{attrs:{"cx":"20","cy":"17","fill":"#DAE2EC","r":"7.2"}})])
          )
        }
      }
    